import React from 'react';
import { Col, Row } from '../../../lib/utils';
import { Body2Regular, Body3Regular, CaptionLight } from '../../../lib/font';
import { colors } from '../../../lib/colors';
import InputSquareDropDown from '../../DropDown/InputSquareDropDown';
import dayjs, { Dayjs } from 'dayjs';
import WhiteRoundButton from '../../Button/WhiteRoundButton';
import ColorRoundButton from '../../Button/ColorRoundButton';
import ThreeButton from '../../Button/ThreeButton';

const CreateEtcScheduleRight = ({
    coachOption,
    coach,
    handleCoachSelect,
    selectedDay,
    setIsCalendar,

    handleEndTimeSelect,
    handleStartTimeSelect,
    startTime,
    endTime,
    timeList,
    onClickAddTime,
    onClickSubTime,

    repeatType,
    setRepeatType,
    repeatCount,
    onChangeRepeatCount,
    repeatPreviewDates,
    maxRepeatCount,
    repeatTypeLabel,
}: any) => {
    const parsedRepeatCount = Number(repeatCount);
    const isRepeatCountValid = Number.isInteger(parsedRepeatCount) && parsedRepeatCount > 0;
    const isRepeatCountOver = isRepeatCountValid && parsedRepeatCount > maxRepeatCount;
    // 종료가 오전 12:00 이면 서버가 '익일 00:00'으로 해석한다. 미리보기에도 그대로 드러낸다.
    const isEndAtMidnight = dayjs(endTime?.value).format('HH:mm') === '00:00';

    return (
        <Col style={{ width: 470, marginLeft: 125 }}>
            <Col style={{ width: 382, height: 152, justifyContent: 'space-between' }}>
                <Body3Regular style={{ color: colors.LAVEL_4 }}> {'날짜'}</Body3Regular>

                {/* OFF 일정과 동일한 UX. 다만 '오늘만'은 임의 날짜에도 쓰이는 문구라 '반복 안 함'으로 쓴다 */}
                <ThreeButton
                    isFirst={repeatType === 'none'}
                    isSecond={repeatType === 'everyWeek'}
                    isThird={repeatType === 'everyDay'}
                    firstText={'반복 안 함'}
                    secondText={'매주 반복'}
                    thirdText={'매일 반복'}
                    firstCallBack={() => setRepeatType('none')}
                    secondCallBack={() => setRepeatType('everyWeek')}
                    thirdCallBack={() => setRepeatType('everyDay')}
                />

                <InputSquareDropDown
                    selectedGender={coach}
                    genderOptions={coachOption}
                    handleGenderSelect={handleCoachSelect}
                    customStyle={{ width: 382 }}
                    isJustClick={true}
                    justClickString={dayjs(selectedDay).format('YYYY년 M월 D일(ddd)')}
                    justClickCallBack={() => setIsCalendar(true)}
                    zIndex={90}
                />
            </Col>

            {repeatType !== 'none' && (
                <Col style={{ width: 470, marginTop: 40 }}>
                    <Row style={{ alignItems: 'center' }}>
                        <Body3Regular style={{ color: colors.LAVEL_4 }}>{'반복 횟수'}</Body3Regular>
                        <CaptionLight style={{ color: colors.LAVEL_2, marginLeft: 8 }}>
                            {`${repeatTypeLabel} 반복은 최대 ${maxRepeatCount}회까지 등록할 수 있습니다.`}
                        </CaptionLight>
                    </Row>

                    <Row style={{ alignItems: 'center', marginTop: 16 }}>
                        <input
                            value={repeatCount}
                            onChange={(e) => onChangeRepeatCount(e.target.value.toString())}
                            type="text"
                            inputMode="numeric"
                            placeholder="반복 횟수를 입력해주세요!"
                            style={{
                                width: 250,
                                height: 48,
                                borderBottom: '1px solid #a6bfef',
                                paddingLeft: 16,
                                fontSize: 18,
                            }}
                        />
                        <Body3Regular style={{ color: colors.LAVEL_3, marginLeft: 12 }}>{'회'}</Body3Regular>
                    </Row>

                    <CaptionLight
                        style={{ color: isRepeatCountOver ? colors.ERROR : colors.LAVEL_2, marginLeft: 8, marginTop: 16 }}
                    >
                        {isRepeatCountOver
                            ? `*${repeatTypeLabel} 반복은 최대 ${maxRepeatCount}회까지만 등록할 수 있습니다`
                            : isRepeatCountValid
                            ? `*최초 일정 포함 총 ${parsedRepeatCount}회가 등록됩니다`
                            : '*최초 일정을 포함한 총 횟수를 입력해주세요'}
                    </CaptionLight>

                    <CaptionLight style={{ color: colors.LAVEL_2, marginLeft: 8, marginTop: 8 }}>
                        {'*한 회차라도 기존 일정과 겹치면 전체가 등록되지 않습니다'}
                    </CaptionLight>
                </Col>
            )}

            <Col style={{ width: 470, height: 162, marginTop: 64 }}>
                <Body3Regular style={{ color: colors.LAVEL_4 }}> {'시간'}</Body3Regular>

                <Row style={{ width: 470, alignItems: 'center', justifyContent: 'space-between', marginTop: 16 }}>
                    {timeList && (
                        <InputSquareDropDown
                            selectedGender={startTime}
                            genderOptions={timeList}
                            handleGenderSelect={handleStartTimeSelect}
                            isDefaultScroll={true}
                        />
                    )}

                    <Body2Regular style={{ color: colors.BLUE_500 }}>~</Body2Regular>
                    {timeList && (
                        <InputSquareDropDown
                            selectedGender={endTime}
                            genderOptions={timeList}
                            handleGenderSelect={handleEndTimeSelect}
                            isDefaultScroll={true}
                        />
                    )}
                </Row>
                <CaptionLight style={{ color: colors.LAVEL_1, marginLeft: 8, marginTop: 16 }}>
                    *일정에 소요되는 시간만큼 추가해주세요!
                </CaptionLight>

                <Row
                    style={{
                        width: 470,
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginTop: 16,
                    }}
                >
                    <WhiteRoundButton
                        customStyle={{ width: 60, height: 24 }}
                        text="-30분"
                        callBack={() => {
                            onClickSubTime(30);
                        }}
                        size="tiny"
                    />
                    <WhiteRoundButton
                        customStyle={{ width: 60, height: 24 }}
                        text="-20분"
                        callBack={() => {
                            onClickSubTime(20);
                        }}
                        size="tiny"
                    />
                    <WhiteRoundButton
                        customStyle={{ width: 60, height: 24 }}
                        text="-10분"
                        callBack={() => {
                            onClickSubTime(10);
                        }}
                        size="tiny"
                    />

                    <ColorRoundButton
                        customStyle={{ width: 60, height: 24 }}
                        text="+10분"
                        callBack={() => {
                            onClickAddTime(10);
                        }}
                        size="tiny"
                    />
                    <ColorRoundButton
                        customStyle={{ width: 60, height: 24 }}
                        text="+20분"
                        callBack={() => {
                            onClickAddTime(20);
                        }}
                        size="tiny"
                    />
                    <ColorRoundButton
                        customStyle={{ width: 60, height: 24 }}
                        text="+30분"
                        callBack={() => {
                            onClickAddTime(30);
                        }}
                        size="tiny"
                    />
                </Row>
            </Col>

            {/*
              * 반복 미리보기 목록.
              * 표시 전용이며, 실제 생성될 날짜는 서버가 KST 기준으로 recurrence 를 전개해 확정한다.
              */}
            {repeatType !== 'none' && repeatPreviewDates && repeatPreviewDates.length > 0 && (
                <Col
                    style={{
                        width: 470,
                        marginTop: 40,
                        border: '1px solid #C3D4F4',
                        borderRadius: 8,
                        padding: 16,
                    }}
                >
                    <Col style={{ marginBottom: 12 }}>
                        <Row style={{ alignItems: 'center', justifyContent: 'space-between' }}>
                            <Body3Regular style={{ color: colors.LAVEL_4 }}>{'등록 예정 일정'}</Body3Regular>
                            <CaptionLight style={{ color: colors.LAVEL_2 }}>
                                {`${dayjs(startTime?.value).format('A hh:mm')} ~ ${
                                    isEndAtMidnight ? '익일 ' : ''
                                }${dayjs(endTime?.value).format('A hh:mm')}`}
                            </CaptionLight>
                        </Row>

                        {/* 목록이 200행까지 길어지므로 총 회차·기간과 자정 안내는 헤더에서 먼저 보이게 둔다. */}
                        <Row style={{ alignItems: 'center', justifyContent: 'space-between', marginTop: 6 }}>
                            <CaptionLight style={{ color: colors.LAVEL_2 }}>
                                {`총 ${repeatPreviewDates.length}회 · ${repeatPreviewDates[0].format(
                                    'YYYY-MM-DD'
                                )} ~ ${repeatPreviewDates[repeatPreviewDates.length - 1].format('YYYY-MM-DD')}`}
                            </CaptionLight>
                            {isEndAtMidnight && (
                                <CaptionLight style={{ color: colors.LAVEL_2 }}>
                                    {'각 회차는 다음 날 0시 종료'}
                                </CaptionLight>
                            )}
                        </Row>
                    </Col>

                    <Col style={{ maxHeight: 160, overflowY: 'auto' }}>
                        {repeatPreviewDates.map((date: Dayjs, index: number) => (
                            <Row
                                key={`${date.valueOf()}-${index}`}
                                style={{
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginTop: index === 0 ? 0 : 8,
                                }}
                            >
                                <CaptionLight style={{ color: colors.LAVEL_2 }}>{`${index + 1}회차`}</CaptionLight>
                                <Body3Regular style={{ color: colors.LAVEL_3 }}>
                                    {date.format('YYYY년 M월 D일(ddd)')}
                                </Body3Regular>
                            </Row>
                        ))}
                    </Col>
                </Col>
            )}
        </Col>
    );
};

export default CreateEtcScheduleRight;
